module.exports = __webpack_public_path__ + "static/media/ic_modif_photo.7c7ce843.svg";